import type { ContextState, GetterClass } from '../../../models'
import { getStateToolKey } from '../utils/get-state-tool-key'
import { mapFilters } from '../utils/map-filters'

export class CurrentFeatureContextGetter implements GetterClass {
  static execute(this: void, state: ContextState): ContextState {
    return {
      ...state,
      // Get the filters, query, and strictMatching from the current context tool if it exists otherwise use the state values directly.
      filters: mapFilters(state.filters, state),
      query: getQuery(state),
      strictMatching: getStrictMatching(state),
      endpointId: getEndpointId(state),
    }
  }
}

function getQuery(state: ContextState): ContextState['query'] {
  if (state.currentFeature) {
    return state[getStateToolKey(state)]?.query ?? state.query
  }

  return state.query
}

function getStrictMatching(state: ContextState): ContextState['strictMatching'] {
  if (state.currentFeature) {
    return state[getStateToolKey(state)]?.strictMatching ?? state.strictMatching
  }

  return state.strictMatching
}

function getEndpointId(state: ContextState): ContextState['endpointId'] {
  if (state.currentFeature) {
    return state[getStateToolKey(state)]?.endpointId ?? state.endpointId
  }

  return state.endpointId
}
